import { cn } from '@/lib/utils';
import type { NavItem } from './nav-config';

const TONE_CLASS = {
  required: 'bg-warning text-warning-foreground',
  recommended: 'bg-muted text-muted-foreground',
} as const;

/** Accessible-label suffix for an item's non-zero extra badges, e.g. ", 2 required, 1 recommended". */
export function extraBadgeLabel(item: NavItem, badges: Record<string, number>): string {
  return (item.extraBadges ?? [])
    .filter((b) => (badges[b.key] ?? 0) > 0)
    .map((b) => `, ${badges[b.key]} ${b.unit}`)
    .join('');
}

/** The item's extra count badges (Attention's required / recommended), hidden at zero. */
export function ExtraNavBadges({
  item,
  badges,
  testIdPrefix,
}: {
  item: NavItem;
  badges: Record<string, number>;
  testIdPrefix?: string;
}) {
  return (
    <>
      {(item.extraBadges ?? [])
        .filter((b) => (badges[b.key] ?? 0) > 0)
        .map((b) => (
          <span
            key={b.key}
            className={cn(
              'flex h-5 min-w-5 items-center justify-center rounded-full px-1.5 text-[10px] font-bold',
              TONE_CLASS[b.tone],
            )}
            data-testid={testIdPrefix ? `${testIdPrefix}-${b.tone}-nav-badge` : undefined}
            aria-hidden="true"
          >
            {badges[b.key]}
          </span>
        ))}
    </>
  );
}
